import axios from 'axios';

const IMAGE_UPLOAD_URL = process.env.REACT_APP_IMAGE_UPLOAD_URL || 'https://t8rlaxfneb.execute-api.ap-south-1.amazonaws.com/prod/';
const BUCKET = 'rietail-file-upload';

const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
const MAX_SIZE = 3 * 1024 * 1024; // 3MB

function validateImage(file) {
  if (!ALLOWED_TYPES.includes(file.type)) return 'Invalid file type. Only JPEG, PNG, JPG, and WEBP are allowed.';
  if (file.size > MAX_SIZE) return 'File size exceeds 3MB limit.';
  return null;
}


export async function uploadImage(file, type = 'background') {
  const error = validateImage(file);
  if (error) throw new Error(error);

  const clientId = sessionStorage.getItem('clientId') || '';
  const formData = new FormData();
  formData.append('single', file);

  const url = `${IMAGE_UPLOAD_URL}rietailimageupload?bucket=${BUCKET}&path=default/${type}`;

  const response = await axios.put(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'client-id': clientId,
      'web-site': '1',
    },
  });

  return {
    url: response.data.url,
    imageName: response.data.originalName,
  };
}
